interface DemoWrapperProps {
    children: React.ReactNode;
    className?: string;
    id?: string;
}

export default function DemoWrapper({ children, className = '', id }: DemoWrapperProps) {
    return (
        <div
            id={id}
            className={`pointer-events-none select-none ${className}`}
            aria-hidden="true"
        >
            {children}
        </div>
    );
}
